module.exports = __webpack_public_path__ + "static/Logo-1d201c132715dc10550468295e129f05.png";